import React from 'react';
import { useLeads } from '../../services/leads';
import './Rebook.css';

/**
 * Rebook — every lead marked "Rebook" from Update Status, newest first, with the reason
 * the agent wrote. Tap one to open the lead and reschedule it.
 */
const lastRebook = (lead) => [...(lead.statusHistory || [])].reverse().find((h) => h.action === 'Rebook');

const when = (iso) => new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

const Rebook = ({ onSelectLead }) => {
  const leads = useLeads().filter((l) => l.stage === 'Rebook');
  const sorted = [...leads].sort((a, b) => ((lastRebook(b) || {}).at || '').localeCompare((lastRebook(a) || {}).at || ''));

  return (
    <div className="rebook">
      <div className="rebook-head">
        <h1>Rebook</h1>
        <p>Customers who need a new inspection time</p>
      </div>
      <div className="rebook-list">
        {sorted.length === 0 && <p className="rebook-empty">Nobody to rebook right now.</p>}
        {sorted.map((l) => {
          const h = lastRebook(l);
          return (
            <button type="button" key={l.id} className="rebook-card" onClick={() => onSelectLead(l)}>
              <div className="rebook-top">
                <b>{l.contactName}</b>
                {h && <span>{when(h.at)}</span>}
              </div>
              <div className="rebook-address">{l.serviceAddress}</div>
              {h && h.note && <div className="rebook-note">“{h.note}”</div>}
              <div className="rebook-chip">↻ Rebook</div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Rebook;
